import { IActionGroup, IStore } from '../index';
import { ILoaderStore } from './store';

export interface ILoaderActions {
  start: () => { loader: ILoaderStore };
  end: () => { loader: ILoaderStore };
}

const actions: IActionGroup = {
  end: ({ loader }: IStore): { loader: ILoaderStore } => {
    const activeRequests = loader.activeRequests - 1;
    return {
      loader: {
        ...loader,
        activeRequests,
        isOpen: activeRequests > 0
      }
    };
  },
  start: ({ loader }: IStore): { loader: ILoaderStore } => {
    const activeRequests = loader.activeRequests + 1;
    return {
      loader: {
        ...loader,
        activeRequests,
        isOpen: activeRequests > 0
      }
    };
  }
};

export default actions;
